/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { formatDateLocal, type NotificationDetail, type PANotification } from '@poweralpha/common';

const formatRuns = (succeeded: number | null | undefined, failed: number | null | undefined) =>
  [
    succeeded != null ? `${succeeded} succeeded` : undefined,
    failed ? `${failed} failed` : undefined,
  ]
    .filter(Boolean)
    .join(' · ');

// Key/value facts shown in the notification center detail pane. Built from
// meta while formatting because UI notifications do not keep meta.
export const getNotificationDetails = (
  { meta, workflow_name }: Pick<PANotification, 'meta' | 'workflow_name'>,
  projectNames: Array<string> | undefined,
): Array<NotificationDetail> => {
  const projects = projectNames?.filter(Boolean) ?? [];
  const conversation = meta.agent_conversation_title ?? meta.agent_conversation_share?.title;
  const runs = formatRuns(meta.num_successes, meta.num_of_errors);

  return [
    projects.length > 0
      ? { label: projects.length > 1 ? 'Projects' : 'Project', value: projects.join(', ') }
      : undefined,
    workflow_name ? { label: 'Workflow', value: workflow_name } : undefined,
    meta.bid_request
      ? { label: 'Bid request', value: `${meta.bid_request.name} · v${meta.bid_request.version}` }
      : undefined,
    meta.bid_request?.opportunity_name
      ? { label: 'Opportunity', value: meta.bid_request.opportunity_name }
      : undefined,
    conversation ? { label: 'Conversation', value: conversation } : undefined,
    runs ? { label: 'Runs', value: runs } : undefined,
    meta.started ? { label: 'Started', value: formatDateLocal(meta.started) } : undefined,
  ].filter((detail): detail is NotificationDetail => Boolean(detail));
};
